module.exports = __webpack_public_path__ + "media/img/event/nurse-banner-fa265b3ad2f57bc5af5ebac731148f9c.jpeg";